export const iconStyle = {
  fontSize: "inherit",
  width: "1.25em",
  height: "1em"
};
